import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TextareaAutosize,
  FormHelperText
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { useStore } from "@store/store";
import PlaceTextField from "@components/placeField";
import { materialCommonStyles } from "@utils/materialCommonStyles";
import { CreateJobStyle } from "../style";

function Detail(props) {
  const classes = CreateJobStyle();
  const materilClasses = materialCommonStyles();
  const [state] = useStore();
  const handlePickUpLocation = (item) => {
    props.formik.setFieldValue("pickUpLocation", item.location);
    props.formik.setFieldValue("pickUpLatitude", item.latitude);
    props.formik.setFieldValue("pickUpLongitude", item.longitude);
  };

  const handleDropOffLocation = (item) => {
    props.formik.setFieldValue("dropOffLocation", item.location);
    props.formik.setFieldValue("dropOffLatitude", item.latitude);
    props.formik.setFieldValue("dropOffLongitude", item.longitude);
  };

  const resetLocationPickUp = () => {
    props.formik.setFieldValue("pickUpLocation", "");
    props.formik.setFieldValue("pickUpCtoId", "");
    props.formik.setFieldValue("pickUpLocationType", "");
  }

  const resetLocationDropOff = () => {
    props.formik.setFieldValue("dropOffLocation", "");
    props.formik.setFieldValue("dropOffCtoId", "");
    props.formik.setFieldValue("dropOffLocationType", "");
  }

  const resetAddressPickUp = () => {
    props.formik.setFieldValue("pickUpLocation", "");
    props.formik.setFieldValue("pickUpCtoId", "");
  }

  const resetAddressDropOff = () => {
    props.formik.setFieldValue("dropOffLocation", "");
    props.formik.setFieldValue("dropOffCtoId", "");
  }

  return (
    <>
      <div className="form-row"> {/* Pick Up City - Drop Off City */}
        <div className="form-gourp two-column">
          <FormControl variant="outlined">
            <div className="title-pickDrop">Pick Up</div>
            <label className="label-text">City</label>
            <Select
              id="pickUpCityId"
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              name="pickUpCityId"
              onChange={e => {
                props.formik.handleChange("pickUpCityId")(e);
                setTimeout(() => {
                  props.formik.setFieldTouched("pickUpCityId", true); // Set touched *after* value update
                });
                resetLocationPickUp();
              }}
              value={props.formik.values.pickUpCityId}
              IconComponent={() => <ExpandMore/>}
            >
              <MenuItem value={""} disabled>
                Select City
              </MenuItem>
              {state?.common?.loadingCities ? (
                <MenuItem>Loading...</MenuItem>
              ) : (
                state?.common?.citiesData?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  );
                })
              )}
            </Select>
            <FormHelperText className="error-text">
              {props.formik.touched.pickUpCityId && props.formik.errors.pickUpCityId}
            </FormHelperText>
          </FormControl>
        </div>

        <div className="form-gourp">
          <FormControl variant="outlined">
            <div className="title-pickDrop">Drop Off</div>
            <label className="label-text">City</label>
            <Select
              id="dropOffCityId"
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              name="dropOffCityId"
              onChange={e => {
                props.formik.handleChange("dropOffCityId")(e);
                setTimeout(() => {
                  props.formik.setFieldTouched("dropOffCityId", true); // Set touched *after* value update
                });
                resetLocationDropOff();
              }}
              value={props.formik.values.dropOffCityId}
              IconComponent={() => <ExpandMore/>}
            >
              <MenuItem value={""} disabled>
                Select City
              </MenuItem>
              {state?.common?.loadingCities ? (
                <MenuItem>Loading...</MenuItem>
              ) : (
                state?.common?.citiesData?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  );
                })
              )}
            </Select>
            <FormHelperText className="error-text">
              {props.formik.touched.dropOffCityId && props.formik.errors.dropOffCityId}
            </FormHelperText>
          </FormControl>
        </div>
      </div>

      <div className="form-row"> {/* Pick Up Location Type - Drop Off Location Type */}
        <div className="form-gourp two-column">
          <FormControl variant="outlined">
            <label className="label-text">Location Type</label>
            <Select
              id="pickUpLocationType"
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              name="pickUpLocationType"
              onChange={e => {
                props.formik.handleChange("pickUpLocationType")(e);
                setTimeout(() => {
                  props.formik.setFieldTouched("pickUpLocationType", true); // Set touched *after* value update
                });
                resetAddressPickUp();
              }}
              value={props.formik.values.pickUpLocationType}
              IconComponent={() => <ExpandMore/>}
              disabled={!props.formik.values.pickUpCityId}
            >
              <MenuItem value={""} disabled>Select Location Type</MenuItem>
              <MenuItem value={"1"}>Customer Location</MenuItem>
              <MenuItem value={"2"}>CTO</MenuItem>
            </Select>
            <FormHelperText className="error-text">
              {props.formik.touched.pickUpLocationType && props.formik.errors.pickUpLocationType}
            </FormHelperText>
          </FormControl>
        </div>

        <div className="form-gourp">
          <FormControl variant="outlined">
            <label className="label-text">&nbsp;</label>
            <Select
              id="dropOffLocationType"
              displayEmpty
              className={materilClasses.customSelect}
              MenuProps={{
                classes: {paper: materilClasses.customSelect},
              }}
              name="dropOffLocationType"
              onChange={e => {
                props.formik.handleChange("dropOffLocationType")(e);
                setTimeout(() => {
                  props.formik.setFieldTouched("dropOffLocationType", true); // Set touched *after* value update
                });
                resetAddressDropOff();
              }}
              value={props.formik.values.dropOffLocationType}
              IconComponent={() => <ExpandMore/>}
              disabled={!props.formik.values.dropOffCityId}
            >
              <MenuItem value={""} disabled>Select Location Type</MenuItem>
              <MenuItem value={"1"}>Customer Location</MenuItem>
              <MenuItem value={"2"}>CTO</MenuItem>
            </Select>
            <FormHelperText className="error-text">
              {props.formik.touched.dropOffLocationType && props.formik.errors.dropOffLocationType}
            </FormHelperText>
          </FormControl>
        </div>
      </div>

      <div className="form-row"> {/* Pick Up Address/CTO Name - Drop Off Address/CTO Name */}
        <div className="form-gourp two-column">
          <FormControl variant="outlined" className={classes.formControl}>
            <span className="label-text">Address / CTO Name</span>
            {(props.formik.values.pickUpLocationType === "1" || !props.formik.values.pickUpLocationType) && (
              <div>
                <PlaceTextField
                  handleChange={(address) =>
                    props.handleChange(address, "pickUpLocation")
                  }
                  handleSelect={(address) =>
                    props.handleSelect(address, "pickUpLocation")
                  }
                  value={props.formik.values.pickUpLocation}
                  disabled={!props.formik.values.pickUpLocationType}
                />
                <FormHelperText className="error-text">
                  {(props.formik.touched.pickUpLocation ||
                      props.formik.touched.pickUpLongitude) &&
                    (props.formik.errors.pickUpLocation ||
                      props.formik.errors.pickUpLongitude)}
                </FormHelperText>
              </div>)
            }

            {props.formik.values.pickUpLocationType === "2" && (
              <div>
                <Select
                  displayEmpty
                  className={`${materilClasses.customSelect} full-width-element`}
                  MenuProps={{
                    classes: {paper: materilClasses.customSelect},
                  }}
                  onChange={props.formik.handleChange("pickUpCtoId")}
                  value={props.formik.values.pickUpCtoId}
                  IconComponent={() => <ExpandMore/>}
                >
                  <MenuItem value={""} disabled>
                    Select CTO
                  </MenuItem>
                  {state?.cto?.loadingPickUpCto ? (
                    <MenuItem>Loading...</MenuItem>
                  ) : (
                    state?.cto?.pickUpCtoData?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item.id}
                          onClick={() => handlePickUpLocation(item)}
                        >
                          {item.name}
                        </MenuItem>
                      );
                    })
                  )}
                </Select>
                <FormHelperText className="error-text">
                  {props.formik.touched.pickUpCtoId && props.formik.errors.pickUpCtoId}
                </FormHelperText>
              </div>)
            }

          </FormControl>

        </div>

        {/*=======================*/}

        <div className="form-gourp">
          <FormControl variant="outlined" className={classes.formControl}>
            <span className="label-text">&nbsp;</span>
            {(props.formik.values.dropOffLocationType === "1" || !props.formik.values.dropOffLocationType) && (
              <div>
                <PlaceTextField
                  handleChange={(address) =>
                    props.handleChange(address, "dropOffLocation")
                  }
                  handleSelect={(address) =>
                    props.handleSelect(address, "dropOffLocation")
                  }
                  value={props.formik.values.dropOffLocation}
                  disabled={!props.formik.values.dropOffLocationType}
                />
                <FormHelperText className="error-text">
                  {(props.formik.touched.dropOffLocation ||
                      props.formik.touched.dropOffLongitude) &&
                    (props.formik.errors.dropOffLocation ||
                      props.formik.errors.dropOffLongitude)}
                </FormHelperText>
              </div>)
            }

            {props.formik.values.dropOffLocationType === "2" && (
              <div>
                <Select
                  displayEmpty
                  className={`${materilClasses.customSelect} full-width-element`}
                  MenuProps={{
                    classes: {paper: materilClasses.customSelect},
                  }}
                  onChange={props.formik.handleChange("dropOffCtoId")}
                  value={props.formik.values.dropOffCtoId}
                  IconComponent={() => <ExpandMore/>}
                >
                  <MenuItem value={""} disabled>
                    Select CTO
                  </MenuItem>
                  {state?.cto?.loadingDropOffCto ? (
                    <MenuItem>Loading...</MenuItem>
                  ) : (
                    state?.cto?.dropOffCtoData?.map((item, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={item.id}
                          onClick={() => handleDropOffLocation(item)}
                        >
                          {item.name}
                        </MenuItem>
                      );
                    })
                  )}
                </Select>
                <FormHelperText className="error-text">
                  {props.formik.touched.dropOffCtoId && props.formik.errors.dropOffCtoId}
                </FormHelperText>
              </div>)
            }
          </FormControl>
        </div>
      </div>

      <div className="form-row"> {/* Job Description */}
        <div className="form-gourp full-width">
          <FormControl variant="outlined" className={classes.formControl}>
            <label className="label-text" htmlFor="description">
              Job description
            </label>
            <TextareaAutosize
              rowsMax={3}
              id="description"
              aria-label="description"
              placeholder="Description"
              onChange={props.formik.handleChange("description")}
              value={props.formik.values.description}
            />
            <FormHelperText className="error-text">
              {props.formik.touched.description &&
                props.formik.errors.description}
            </FormHelperText>
          </FormControl>
        </div>
      </div>
    </>
  );
}

export default Detail;
